export interface CompanyStateI {
  locations: any[];
  users: any[];
  clients: any[];
  carePartners: any[];
  careManagerActivities: any[];
  applicants: any[];
  awardTypes: any[];
  deactivationReasons: any[];
  lostClientReasons: any[];
  applicantStages: any[];
  referralPartner: any[]; 
  companies: any[];
  prospect: any[];
  milestones: any[];
  ratings: any[];
  companyRatings: any[];
  activityTypes: any[];
  companyTypes: any[];
  applicantsActivity:any[];
  leadSources: any[];
  referralActivityTypes: any[];

}

const companyInitialState: CompanyStateI = {
  locations: [],
  users: [],
  clients: [],
  carePartners: [],
  careManagerActivities: [],
  applicants: [],
  awardTypes: [],
  deactivationReasons: [],
  lostClientReasons: [],
  applicantStages:[],
  referralPartner: [],
  companies: [],
  prospect: [],
  milestones: [],
  ratings: [],
  companyRatings: [],
  activityTypes: [],
  companyTypes: [],
  applicantsActivity:[],
  leadSources: [],
  referralActivityTypes: [],
};

export { companyInitialState };
